import React, { Component } from "react";

import styled from "styled-components";

const MainImage = styled.img`
  height: 100px;
  border: solid 2px lightgray;
  cursor: pointer;
  border-radius: 5px;
`;

class Image extends Component {
  state = {};
  render() {
    const { source } = this.props;
    return <MainImage src={source} alt="Not Found" />;
  }
}

export default Image;
